import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ID8_GEN_TYPES } from '../../constants';

const useImagesGenerationStatus = ({ genType }) => {
  const imagesContent = useSelector(mappedPromptTypeContentSelector[genType]);
  const activeGeneratingStatuses = useSelector((state) => state.id8.activeGeneratingStatuses);

  const isActiveGeneration = useMemo(() => activeGeneratingStatuses[genType], [activeGeneratingStatuses, genType]);

  return useMemo(() => {
    const isSomeImagesGenerating = imagesContent.some((frame) => frame.generating);

    return isActiveGeneration || isSomeImagesGenerating;
  }, [imagesContent, isActiveGeneration]);
};

export default useImagesGenerationStatus;

const mappedPromptTypeContentSelector = {
  [ID8_GEN_TYPES.IMAGES]: (state) => state.id8.imagesContent,
  [ID8_GEN_TYPES.RECREATE]: (state) => state.id8.adImagesContent,
};
